<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <LoginModel :visible="isShowLoginModel"></LoginModel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LoginModel from "./components/LoginModel";
export default {
  components: {
    LoginModel
  },
  computed: {
    ...mapGetters(["isShowLoginModel"])
  }
};
</script>



<style lang="scss">
body {
  margin: 0;
  padding: 0;
}
div {
  box-sizing: border-box;
}
a {
  color: #2abfc3;
  text-decoration: none;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.container {
  width: 100%;
  overflow-x: hidden;
  background-color: #fff;
}
</style>
